import { LOCALES } from '@/i18n'
import { useLocale } from '@/i18n/LocaleProvider'

export function LanguageSwitcher({ compact = false }: { compact?: boolean }) {
  const { locale, setLocale, t } = useLocale()
  return (
    <div className={compact ? 'shrink-0' : 'mt-4'}>
      <div className="flex flex-wrap items-center gap-1" role="group" aria-label={t('i18n.language')}>
        {LOCALES.map((code) => {
          const on = locale === code
          return (
            <button
              key={code}
              type="button"
              aria-pressed={on}
              onClick={() => setLocale(code)}
              className={[
                'min-h-11 min-w-11 rounded-md px-2 text-xs font-medium uppercase',
                on
                  ? 'bg-slate-100 text-slate-900'
                  : 'border border-surface-border text-slate-400 hover:text-slate-200',
              ].join(' ')}
            >
              {code}
            </button>
          )
        })}
      </div>
    </div>
  )
}
